import { render } from "./PriceTable.vue?vue&type=template&id=512d6925&scoped=true"
import script from "./PriceTable.vue?vue&type=script&lang=js"
export * from "./PriceTable.vue?vue&type=script&lang=js"

import "./PriceTable.vue?vue&type=style&index=0&id=512d6925&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512d6925"]])

export default __exports__